import { gql } from '@apollo/client';

const UPDATE_SITE_USER = gql`
  mutation UpdateSiteUser($siteUser: SiteUserInput) {
    updateSiteUser(siteUser: $siteUser) {
      message
      success
      siteUser {
				id				
        avatar
				companyName
				email
				isCurrentUser
				lastLoggedIn
				name
				siteId
				siteRoleId
				siteRoleName
				status
				sufficentSubscriptionLevel
				telephone
      }
    }
  }
`;

export default UPDATE_SITE_USER;
